// extracted by mini-css-extract-plugin
export default {"MarkdownPage":"MarkdownGamePage_MarkdownPage__St4Vl"};